// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__2gz4s","image":"Banner_image__Nayqe","image--mobile":"Banner_image--mobile__2eDpX","image--desktop":"Banner_image--desktop__xV67A"};